const getCinemasPerMovie = (performances) => {
    let cinemas = []
    performances.map(perf => {
        if(!_.contains(cinemas, perf.cinema)) {
            cinemas.push(perf.cinema)
        }
    })

    return cinemas
}

export default getCinemasPerMovie
